export interface IModeOption {
    value: string;
    label: string;
}

export const modeOptions: IModeOption[] = [
    { value: "optional", label: "Optional" },
    { value: "required", label: "Required" }
];
